import { render } from "./Printheads.vue?vue&type=template&id=4d707a57&scoped=true"
import script from "./Printheads.vue?vue&type=script&lang=js"
export * from "./Printheads.vue?vue&type=script&lang=js"

import "./Printheads.vue?vue&type=style&index=0&id=4d707a57&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d707a57"]])

export default __exports__